import { useScrollToTop } from '@lair-finance/util'
import { useCloseMenuOnDisconnect } from '@/domains/header/hooks/useCloseMenuOnDisconnect.ts'
import { useCloseMenuOnResize } from '@/domains/header/hooks/useCloseMenuOnResize.ts'

export function useAppHooks() {
  useScrollToTop()

  useCloseMenuOnDisconnect()
  useCloseMenuOnResize()
}
